module.exports = __webpack_public_path__ + "img/pichai.5013355f.jpg";